import { useBreakpoint } from 'hooks/useBreakpoint';
import { usePrevious } from 'hooks/usePrevious';
import { IProduct } from 'modules/ScrShopNew/store/slices/products/types';
import { useState, useRef, useEffect } from 'react';

interface ISliderIndex {
  packages: IProduct[];
  slickGoTo: (index: number) => void;
  matchedPackage?: IProduct;
}

export const useSliderIndex = ({ packages, slickGoTo, matchedPackage }: ISliderIndex) => {
  const [sliderIndex, setSliderIndex] = useState<number>(0);

  const isDesktop = useBreakpoint('desktopXl');
  const previousDesktopValue = usePrevious(isDesktop);
  const orientationWasChanged = isDesktop !== previousDesktopValue;

  const initialPackageWasSet = useRef(false);

  const setInitialSliderIndex = () => {
    const initialSlideIdx = !isDesktop
      ? packages.findIndex((pckg) => pckg._id === matchedPackage?._id)
      : 0;

    setSliderIndex(initialSlideIdx);
    slickGoTo(initialSlideIdx);
  };

  useEffect(() => {
    if (initialPackageWasSet.current || !packages.length) return;
    setInitialSliderIndex();

    initialPackageWasSet.current = true;
  }, [packages.length, matchedPackage]);

  useEffect(() => {
    if (orientationWasChanged) {
      setInitialSliderIndex();
    }
  }, [orientationWasChanged]);

  return { sliderIndex, setSliderIndex };
};
